import {UserRoleContext} from '@/helpers/UserRole/UserRoleProvider'
import {getCountries} from '@/helpers/envConfig'
import {useJourneyMetaConfig} from '@/hooks/useJourneyMetaConfig'
import {store} from '@/store'
import {selectMarket, selectShellActive} from '@/store/slices/commonSlice'
import {setJourneyMeta} from '@ReduxActions'
import {useContext, useEffect, useMemo} from 'react'
import {useSelector} from 'react-redux'

export const useCountries = (_userAccessRules?: string[]) => {
  const {userAccessRules} = useContext(UserRoleContext)
  const shellActive = useSelector(selectShellActive)
  const market = useSelector(selectMarket)

  const countries = useMemo(() => {
    const countriesFromUser = _userAccessRules || userAccessRules
    const allCountries = getCountries()
    const filteredCountries = allCountries.filter(country => countriesFromUser.includes(country))
    return countriesFromUser.length ? filteredCountries : allCountries
  }, [_userAccessRules, userAccessRules])

  const {country} = useJourneyMetaConfig()

  useEffect(() => {
    if (shellActive) {
      if (market) {
        store.dispatch(setJourneyMeta({country: market}))
      }
      return
    }

    if (country && countries.includes(country)) {
      return
    }

    store.dispatch(setJourneyMeta({country: countries[0]}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shellActive, market])

  return {countries, country}
}
